import { useEffect, useState } from "react";

import { useFeatureFlags } from "~/shared/hooks/use-feature-flags.ts";

/**
 * Hook that gates a feature behind a LaunchDarkly feature flag.
 * Returns loading state and whether the feature is enabled.
 *
 * @param flagKey - The LaunchDarkly feature flag key to check
 * @returns Object containing isReady (loading state) and isEnabled (flag value)
 */
export function useFeatureFlagGate(flagKey: string) {
	const { flags, ldClient } = useFeatureFlags();
	const [isReady, setIsReady] = useState(false);
	const isEnabled = flags[flagKey] === true;
	const flagValue = flags[flagKey] as unknown;

	useEffect(() => {
		const initialize = async () => {
			if (ldClient) {
				await ldClient.waitUntilReady();
				setIsReady(true);
			}
		};
		initialize();
	}, [ldClient]);

	return { isReady, isEnabled, flagValue };
}
